module.exports = __webpack_public_path__ + "static/media/quickCards.3eb0b182.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/app-composer/concierge/images/quickCards.png
// module id = 273
// module chunks = 0